import LayerGroup from 'ol/layer/Group';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import { urlWMSInundaciones, formatoPNG } from './configuracion';

const layer00162 = new TileLayer({
  title: 'Máscara 20110905',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20110905l5tm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00162.setVisible(false);

const layer00161 = new TileLayer({
  title: 'Máscara 20110913',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20110913l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00161.setVisible(false);

const layer00160 = new TileLayer({
  title: 'Máscara 20111015',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20111015l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00160.setVisible(false);

const layer00159 = new TileLayer({
  title: 'Máscara 20111031',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20111031l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00159.setVisible(false);
  
const layer00158 = new TileLayer({
  title: 'Máscara 20120103',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20120103l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00158.setVisible(false);
  
const layer00157 = new TileLayer({
  title: 'Máscara 20120119',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20120119l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00157.setVisible(false);
 
const layer00156 = new TileLayer({
  title: 'Máscara 20120204',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20120204l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00156.setVisible(false);

const layer00155 = new TileLayer({
  title: 'Máscara 20120220',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20120220l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00155.setVisible(false);
  
const layer00154 = new TileLayer({
  title: 'Máscara 20120307',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20120307l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00154.setVisible(false);

const layer00153 = new TileLayer({
  title: 'Máscara 20120424',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20120424l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00153.setVisible(false);

const layer00152 = new TileLayer({
  title: 'Máscara 20120510',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20120510l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00152.setVisible(false);
  
const layer00151 = new TileLayer({
  title: 'Máscara 20120814',
  source: new TileWMS({
    url: urlWMSInundaciones,
    params: {LAYERS: '20120814l7etm202_34_GRN1_inund', format: formatoPNG},
    gutter: 200,
  })
});
layer00151.setVisible(false);

export const grupoCapa01_10 = new LayerGroup({
  title: 'Ciclo Hidrológico 2011-2012',
  fold: 'close',
  layers: [layer00151, layer00152, layer00153, layer00154, layer00155, layer00156, layer00157, layer00158, layer00159, layer00160, layer00161, layer00162]
});